// Balloon animations
export const ANIMTION_BALLOON = {
  GRAVITY: 0.1,
  AIR_RESISTANCE: 0.99,
  MAX_VELOCITY_X: 12,
  MAX_VELOCITY_Y: 16,
  UPWARD_FORCE: 10,
  SLIDE_FORCE: 6,
};
